import { AuditAreaCell, AuditTypeCell, AuditValueCell, EditActionCell } from '@med-fe/ui';
import { Button } from 'antd';

export const resource_cleanup_columns = [
  {
    title: 'File Name',
    dataIndex: 'fileName',
    key: 'actionType',
    width: 200,
    ellipsis: true,
  },
  {
    title: 'Uploaded By',
    dataIndex: 'uploadBy',
    key: 'user',
    width: 124,
    ellipsis: true,
  },
  {
    title: 'Uploaded Date',
    dataIndex: 'uploadDate',
    key: 'date',
    width: 100,
    ellipsis: true,
  },
  {
    title: 'Total Rows',
    dataIndex: 'totalRows',
    key: 'totalRows',
    width: 80,
    ellipsis: true,
  },
  {
    title: 'Validate Cleanup',
    dataIndex: 'id',
    key: 'resourceValidation',
    ellipsis: true,
    width: 400,
  },
  {
    title: 'Process Cleanup',
    dataIndex: 'id',
    key: 'processCleanup',
    width: 300,
    ellipsis: true,
  },
  {
    title: 'Download File',
    dataIndex: 'id',
    key: 'download',
    width: 100,
    ellipsis: true,
  },
  {
    title: 'Delete File',
    dataIndex: 'id',
    key: 'deleteFile',
    width: 100,
    ellipsis: true,
  },
];
